module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('logo'), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Learn nades the easy way.")]), _vm._v(" "), _c('div', {
    staticClass: "search row"
  }, [_c('div', {
    staticClass: "search__content col-xs-12"
  }, [_c('search-bar', {
    attrs: {
      "keyword": _vm.keyword,
      "options": _vm.options,
      "placeholder": "Search a game"
    },
    on: {
      "input": _vm.handleKeywordChange,
      "select": _vm.handleOptionSelect
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "popular row center-xs"
  }, _vm._l((_vm.popularGames), function(game) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-3 col-md-2 col-lg-2"
    }, [_c('div', {
      staticClass: "popular__item drop-shadow",
      style: (("background-image:url(" + (game.thumbnail) + ")"))
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'MapSelection',
          params: {
            game: game.slug
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(game.title) + "\n        ")])], 1)])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popular-title row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "popular-title__content"
  }, [_c('h2', [_vm._v("\n          Popular games:\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f9d630","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Home/index.vue
// module id = 706
// module chunks = 1